import { IStack } from "../interfaces/istack";

export class Stack<T> implements IStack<T> {
	private list: T[] = [];

	get length() {
		return this.list.length;
	}

	peek(): T | undefined {
		if (this.list.length > 0) {
			return this.list[0];
		}
		return undefined;
	}

	pop(): T | undefined {
		if (this.list.length > 0) {
			const element = this.list[0];
			this.list.splice(0, 1);
			return element;
		}
		return undefined;
	}

	push(item: T): void {
		this.list.push(item);
	}

	size(): number {
		return this.list.length;
	}
}
